<template>
  <div class="mobile-responsive-root">
    <header v-if="showHeader" class="mobile-responsive-header">
      <button
        v-if="showBack"
        type="button"
        class="btn btn-link mobile-back-btn"
        @click="goBack"
        aria-label="Retour"
      >
        <i class="bi bi-arrow-left"></i>
      </button>
      <h1 class="mobile-responsive-title">{{ title }}</h1>
    </header>
    <div class="mobile-responsive-body">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "MobileResponsiveShell",
  props: {
    title: {
      type: String,
      default: "",
    },
    showBack: {
      type: Boolean,
      default: true,
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
    backRoute: {
      type: [String, Object],
      default: null,
    },
  },
  methods: {
    goBack() {
      if (this.backRoute) {
        this.$router.push(this.backRoute);
        return;
      }
      if (window.history.length > 1) {
        this.$router.back();
      } else {
        this.$router.push({ name: "mobile-home-index" });
      }
    },
  },
};
</script>

<style scoped>
.mobile-responsive-root {
  width: 100%;
  min-height: 100%;
  box-sizing: border-box;
}

.mobile-responsive-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 0.5rem;
  padding-top: max(0.75rem, env(safe-area-inset-top));
  position: sticky;
  top: 0;
  z-index: 10;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.12);
}

.mobile-back-btn {
  color: #fff !important;
  padding: 0.25rem 0.5rem;
  font-size: 1.35rem;
  line-height: 1;
  text-decoration: none;
  flex-shrink: 0;
}

.mobile-responsive-title {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 700;
  line-height: 1.3;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.mobile-responsive-body {
  width: 100%;
  max-width: 100vw;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  padding: 0.75rem;
  padding-bottom: max(1rem, env(safe-area-inset-bottom));
  box-sizing: border-box;
}

/* Deep: make tables and bootstrap rows usable on small screens */
.mobile-responsive-body ::v-deep .row {
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}

.mobile-responsive-body ::v-deep .row.justify-content-end {
  flex-wrap: wrap;
  gap: 0.5rem;
  justify-content: flex-start !important;
}

.mobile-responsive-body ::v-deep .col,
.mobile-responsive-body ::v-deep [class*="col-"] {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}

.mobile-responsive-body ::v-deep .btn {
  white-space: normal;
  text-align: center;
}

.mobile-responsive-body ::v-deep table {
  font-size: 0.8rem;
}

.mobile-responsive-body ::v-deep .table-responsive,
.mobile-responsive-body ::v-deep .vue-data-table {
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (min-width: 768px) {
  .mobile-responsive-body {
    padding: 1rem 1.25rem;
  }

  .mobile-responsive-title {
    font-size: 1.2rem;
  }

  .mobile-responsive-body ::v-deep table {
    font-size: inherit;
  }
}
</style>
